import { Reveal } from "@/components/Reveal";
import { SectionHeading, CornerTicks } from "@/components/kit";
import { PROJECT_NAME } from "@/config/actra";

const ARC_STATS = [
    { k: "CHAIN ID", v: "5042" },
    { k: "SETTLEMENT ASSET", v: "USDC" },
    { k: "EVM", v: "COMPATIBLE" },
    { k: "FINALITY", v: "INSTANT" },
];

const CHAIN_VISUAL = ["ACTRA", "VERIFIED ACTION", "USDC", "ARC"];

export const ArcSection = () => (
    <section id="arc" data-testid="arc-section" className="section relative overflow-hidden">
        <div
            className="absolute inset-0 opacity-[0.16]"
            style={{
                background: "radial-gradient(60% 80% at 80% 20%, rgba(22,119,255,0.5) 0%, transparent 65%)",
            }}
            aria-hidden="true"
        />
        <div className="shell relative">
            <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
                <Reveal>
                    <SectionHeading
                        index="08"
                        eyebrow="ARC INTEGRATION"
                        title={
                            <>
                                BUILT FOR <span className="text-[#1677FF]">ARC.</span>
                            </>
                        }
                        description={`${PROJECT_NAME} is designed around an Arc-native settlement experience — Arc is built for financial markets, real-time money movement and agentic economic activity. ${PROJECT_NAME} brings verified actions to that environment.`}
                    />
                    <div className="mt-8 flex flex-wrap gap-2.5" data-testid="arc-chain-visual">
                        {CHAIN_VISUAL.map((c, i) => (
                            <span key={c} className="flex items-center">
                                <span
                                    className={`border px-4 py-2.5 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] transition-all ${
                                        i === CHAIN_VISUAL.length - 1
                                            ? "border-[#1677FF] bg-[#1677FF] text-white"
                                            : "border-white/10 bg-[#0A1627] text-ink"
                                    }`}
                                >
                                    {c}
                                </span>
                                {i < CHAIN_VISUAL.length - 1 && (
                                    <span className="mx-2 font-mono text-xs text-[#1677FF]" aria-hidden="true">
                                        ↓
                                    </span>
                                )}
                            </span>
                        ))}
                    </div>
                    <p className="mt-8 max-w-lg text-xs leading-relaxed text-mute/70">
                        Launching on Arc. Designed for the Arc ecosystem. {PROJECT_NAME} is an independent protocol — not
                        officially affiliated with Circle or Arc.
                    </p>
                </Reveal>

                <Reveal delay={0.12}>
                    <div className="relative p-8 md:p-10">
                        <CornerTicks />
                        <div className="border border-white/[0.08] bg-[#07111F]/80 p-8" data-testid="arc-network-card">
                            <div className="flex items-center justify-between">
                                <p className="font-display text-xl font-bold uppercase tracking-tightest">ARC MAINNET</p>
                                <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.2em] text-[#31D8FF]">
                                    <span className="h-1.5 w-1.5 animate-blink rounded-full bg-[#31D8FF]" /> LIVE TARGET
                                </span>
                            </div>
                            <div className="mt-7 grid grid-cols-2 gap-px bg-white/[0.06]">
                                {ARC_STATS.map((s) => (
                                    <div key={s.k} className="bg-[#0A1627] p-5">
                                        <p className="label-tech">{s.k}</p>
                                        <p className="mt-2 font-display text-lg font-bold text-ink md:text-xl">{s.v}</p>
                                    </div>
                                ))}
                            </div>
                            <p className="mt-6 font-mono text-[9px] uppercase tracking-[0.24em] text-mute/60">
                                NETWORK INFORMATION — LIVE RPC INTEGRATION ARRIVES WITH LAUNCH
                            </p>
                        </div>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);

export default ArcSection;
